import StudyGoalCommunication from '~/pages/communication/studyGoal/libs/components/StudyGoalCommunication'
import { TPageProps } from '~/shared/types/commonTypes'

const StudyGoalCommunicationPage = (props: TPageProps) => (
  <StudyGoalCommunication {...props} />
)

export default StudyGoalCommunicationPage
